<template>
  <div>
    <v-autocomplete
      v-model="seriesSelectModel"
      :items="seriesItems"
        :label="$tc('page.series.label-select-series')"
        return-object
      item-text="text"
      item-value="id"
      dense
      outlined
      @change="selectSeries()"
      class="selectSeries"
      ></v-autocomplete>
  </div>
  
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState, mapMutations } from "vuex";

export default {
  mixins: [apiCalls],
  data() {
    return {
      seriesSelectModel: null,
      seriesItems: [], 
      allSeries: [],
      userCurrent: null
    };
  },
  computed: {
    ...mapState({
      seriesSelected: state => state.series.seriesSelected
    }),
    
  },
  created() {
    this.getSeries();
    this.getUser();
  },
  mounted(){   
    if(this.seriesSelected != null){ 
      this.seriesSelectModel = {value: this.seriesSelected.id, text: this.seriesSelected.seriesName};
      this.selectSeries();
    }
  },
  methods: {
    ...mapMutations(["updateSelectedSerie"]),
    async getSeries(seriesId = null) {
      const response = await this.getApi(
        "/api/v1/promoter/series"
      );
      if(seriesId == null ){
        this.seriesSelectModel = null
        this.updateSelectedSerie(null)
      } 
      if (response != undefined) {  
        let seriesIds = [];
        this.seriesItems = []      
        response.forEach(element => {
          const item = {
            value: element.id,
            text: `${element.id}-${element.seriesName}`
          };

          this.seriesItems.push(item);
          seriesIds.push(element.id);
          if(seriesId == item.value){
            this.seriesSelectModel = item
            this.updateSelectedSerie(element)
          }
        });
        
        this.allSeries = response;
        if(this.seriesSelected) {
          this.seriesSelectModel = {value: this.seriesSelected.id, text: this.seriesSelected.seriesName};
          this.selectSeries();
        } else {
          
          let defaultIdSerie = seriesIds.length > 0 ? Math.max(...seriesIds) : null;
          let item = defaultIdSerie ? this.seriesItems.filter((el) => {
            return el.value == defaultIdSerie;
          }) : [];
          this.seriesSelectModel = item.length > 0 ? item[0] : null;
          if(this.seriesSelectModel)
            this.selectSeries();
          else {
            this.seriesSelectModel = null;
            this.updateSelectedSerie(null);
          }
        }
      }
    },
    selectSeries() {
      if(this.seriesSelectModel) {
      this.allSeries.forEach(element => {
        if (element.id == this.seriesSelectModel.value) {
          this.seriesSelectModel = this.seriesItems.filter( el => {
            return el.value == element.id;
          })[0];
          this.updateSelectedSerie(element);
          if(this.userCurrent) {
            let item = {
              userId: this.userCurrent.id,
              element
            };
            let series_selected_promoter = JSON.parse(localStorage.getItem("series_selected_promoter"));
            if(series_selected_promoter && Array.isArray(series_selected_promoter)) {
              let band = false;
              series_selected_promoter.forEach(ele => {
                if(element.userId == this.userCurrent.id) {
                  ele.element = element;
                  band = true;
                }
              });
              if(!band) {
                series_selected_promoter = [];
                series_selected_promoter.push(item);
              }
            } else {
              series_selected_promoter = [];
              series_selected_promoter.push(item);
            }
            localStorage.setItem("series_selected_promoter", JSON.stringify(series_selected_promoter));
          } 
        }
      });
      }
    },
    async getUser() {
      const getUserCurrent = await this.api("get", "/api/v1/users/current");
      this.userCurrent = getUserCurrent.message;
    }
  },
  watch: {
    userCurrent(val) {
      const series_selected_promoter = JSON.parse(localStorage.getItem("series_selected_promoter"));
      if(series_selected_promoter && Array.isArray(series_selected_promoter)) {
        const userId = val.id;
        const item = series_selected_promoter.find((el) => el.userId == userId);
        if(item) {
          this.seriesSelectModel = {value: item.element.id, text: item.element.seriesName};
          this.selectSeries();
        }
      }
    }
  }
};
</script>

<style>
.selectSeries .v-text-field__details, .selectSeries .v-messages {
  display: none;
}
.selectSeries.v-input {
    font-size: 14px;
}
</style>